import axios from 'axios';
import { API_BASE_URL, API_URLS } from '../config/constants';

const orderService = {
  // Get all orders with filters and pagination
  getAllOrders: async (filters = {}) => {
    try {
      const params = new URLSearchParams();

      // Add filter parameters
      Object.keys(filters).forEach(key => {
        if (filters[key]) {
          params.append(key, filters[key]);
        }
      });

      const response = await axios.get(`${API_BASE_URL}${API_URLS.ORDERS}?${params}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get order by ID
  getOrderById: async (orderId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}${API_URLS.ORDER_BY_ID(orderId)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update order
  updateOrder: async (orderId, orderData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.ORDER_EDIT(orderId)}`, orderData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Update order status
  updateOrderStatus: async (orderId, status) => {
    try {
      const response = await axios.put(`${API_BASE_URL}${API_URLS.ORDER_STATUS(orderId)}`, {
        status: status
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  getDashboardStats: async (params = {}) => {
    try {
      const response = await axios.get(`${API_BASE_URL}api/admin/dashboard/stats`, { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },

  // Get today's summary
  getTodaySummary: async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}api/admin/dashboard/today-summary`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default orderService;